import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  private dialogData: any = {
    header: 'header',
    type: 'confirm',
    isOpen: false,
    isSessionDialogOpen: false,
    buttons: {
      accept: {
        text: 'Yes, Remove',
        action: () => {
          console.log("Accepted");
        },
        background: "#cccc",
        color: '#fff'
      },
      reject: {
        text: 'No',
        action: () => {
          console.log("Rejected");
        },
        background: "#cccc",
        color: '#fff'
      },
    },
  };

  private toasterData: any = {
    content: '',
    type: 'undo',
    hasUndo: false,
    severity: 'success',
    undo: {
      text: 'undo',
      action: () => { }
    },
    close: () => { },
    position: 'bottom-center'
  };

  public dialogDataPromise = new BehaviorSubject<any>(null);
  public $dialogData = this.dialogDataPromise.asObservable();

  public toasterDataPromise = new BehaviorSubject<string>("");
  public $toasterData = this.toasterDataPromise.asObservable();

  constructor() {

  }

  public updateDialogData(data: string) {
    this.dialogDataPromise.next(data);
  }


  public updateToasterData(data: string) {
    this.toasterDataPromise.next(data);
  }

  public getToasterData(isDeep: boolean = true) {
    let data: any = {};
    if (isDeep) {
      data = JSON.parse(JSON.stringify(this.toasterData));
    } else {
      data = JSON.parse(JSON.stringify(this.toasterData));
      data.undo.action = () => { };
      data.close = () => { };
    }
    data.type = 'undo';
    return data;
  }

  public getConfirmData(isDeep: boolean = true) {
    let data: any = {};
    if (isDeep) {
      data.isOpen = true;
      // data = JSON.parse(JSON.stringify(this.dialogData));
      data=this.dialogData;
    } else {
      data = this.dialogData;
    }
    data.type = 'confirm';
    data.isVisible= true;
    return data;
  }

  public showDialog(options: {
    type: string;
    visibility: boolean;
    width?: string;
    header: string;
    body: string;
    action: string;
    reject: string;
    onAccept: () => void;
    onReject: () => void;
}) {
    const dialogConfig = {
        header: options.header,
        type: options.type,
        isOpen: options.visibility,
        width: options.width || '400px',
        body: options.body,
        buttons: {
            accept: {
                text: options.action,
                action: options.onAccept, 
            },
            reject: {
                text: options.reject,
                action: options.onReject, 
            },
        },
    };

    this.dialogDataPromise.next(dialogConfig); 

}
}
